module.exports = __webpack_public_path__ + "static/media/royalcurator_logo_goldtulip.8934bc3b.png";